
<h1 class="outline-title" *ngFor="let i of outlineArrNum" [style]="getOutlineCss()">{{firstLine}}</h1>
<h1 class="title" [style]="getLineCss(1)">{{firstLine}}</h1>
<h1 class="title" *ngIf="secondLine != ''" [style]="getLineCss(2)">{{secondLine}}</h1>
<h1 class="title" *ngIf="thirdLine != ''" [style]="getLineCss(3)">{{thirdLine}}</h1>